module.exports = __webpack_public_path__ + "img/bg.a107fe6d.png";